<template>
  <div class="landing text-center">
    <div class="itemis-logo">
      <img :src="'img/icons/analyzeLogo.png'" alt="Itemis-Analyze" width="400" />
    </div>
    <v-row class="mb-6" no-gutters justify="center">
      <v-col cols="8" offset="0">
        <h2 class="itemis-analyze-headline mb-6">
          {{ labels.LANDING_PAGE.TITLE }}
        </h2>
      </v-col>
      <v-col cols="6" offset="0">
        <h3 class="itemis-analyze-title">
          {{ labels.LANDING_PAGE.DESCRIPTION }}
        </h3>
      </v-col>
    </v-row>
    <template v-if="userData.name">
      <div>
        <p>User: {{ userData.name }}</p>

        <v-btn color="blue" @click="router.push('/projectlist')">{{
          labels.PROJECT_LIST.PROJECT_LIST
        }}</v-btn>
      </div>
    </template>
    <template v-else>
      <p>{{ labels.LANDING_PAGE.SignIn_ERROR }}</p>

      <v-btn color="blue" @click="loadProjectData()">{{
        labels.BUTTONS.GO_TO_ANALYZE_CLOUD
      }}</v-btn>
    </template>
  </div>
</template>
<script lang="ts" setup>
  import { ref } from 'vue'
  import { useRouter } from 'vue-router'
  import labels from '@/translations/labels.json'
  import { useProjectStore } from '@/stores/projectStore'
  import { useUserStore } from '@/stores/modules/user'
  import { useStore } from 'vuex'
  import { injectTyped } from '@/inject'
  import { ServiceKeys } from '@/services/symbols'
  const projectService = injectTyped(ServiceKeys.project)
  const store = {
    userStore: useUserStore(),
    authStore: useStore(),
    projectStore: useProjectStore(),
  }
  const router = useRouter()

  const userData = ref(store.userStore.getUserInfo)

  async function loadProjectData() {
    await store.projectStore.loadProjectsFromApi(projectService)

    const redirectPath = localStorage.getItem('redirectPath')

    if (redirectPath) {
      // Redirect to intended URL for password auth
      localStorage.removeItem('redirectPath')

      router.push({
        path: decodeURIComponent(redirectPath),
      })
    } else if (store.projectStore.projects.length > 0) {
      router.push({
        name: labels.SIDEBAR.MAIN.PROJECT_LIST,
      })
    } else {
      router.push({
        name: 'HomePage',
      })
    }
  }
</script>

<style lang="scss" scoped>
  .itemis-analyze-headline,
  .itemis-analyze-title {
    color: rgb(var(--v-theme-font-color-headline));
  }
  .itemis-logo {
    margin-top: 1.5em;
    margin-bottom: 0.5em;
  }
  .landing {
    margin-top: 1em;
  }
  .loader-position {
    margin-top: 4em;
  }
</style>
